import { cast, getRoot, types } from 'mobx-state-tree';
import { IRootStore } from 'store/root';
import LauncherUpdate from './launcher-update';
import i18next from 'i18next';

const { settings } = window;

const beginMaintTimers: any = {};
const endMaintTimers: any = {};

const GlobalNotification = types
    .model({
        state: types.optional(types.string, ''),
        // message: types.optional(types.string, ''),
        retry: 0,
        launcherUpdate: types.optional(LauncherUpdate, {}),
    })
    .volatile((self) => ({
        socket: null as WebSocket | null,
        pingTimeout: undefined as number | undefined,
        // interval: null as any,
    }))
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
    }))
    .actions((self) => {
        const actions = {
            open(event: Event) {
                self.state = 'connected';
                self.retry = 0;
                actions.ping();
            },
            message(event: MessageEvent) {
                const d = JSON.parse(event.data);
                switch (d.headers.eventType) {
                    case 'PresencePong':
                        self.root.systemInfo.setServerTime(d.body.serverTime);
                        return;
                    case 'LauncherUpdate':
                        self.launcherUpdate = cast(d.body);
                        self.launcherUpdate.exec();
                        break;
                    case 'MaintenanceStart':
                        {
                            const { productId, begin, end, messages, maintenanceMode } = d.body;
                            const product = self.root.appStore.library.find((x) => x.productId === productId);
                            let message = messages.find((x: any) => x.lang === self.root.systemInfo.lang);
                            message = message ? message.message : messages.find((x: any) => x.lang === 'en').message;
                            // set maintenance start timer
                            if (beginMaintTimers[productId]) clearTimeout(beginMaintTimers[productId]);
                            let sleepTime = begin * 1000 - Date.now();
                            sleepTime = sleepTime > 0 ? sleepTime : 0;
                            beginMaintTimers[productId] = setTimeout(() => {
                                product?.maintenance.set(maintenanceMode, message);
                                if (product?.trayNoticeAvailable)
                                    window.ipcRenderer.invoke(
                                        'showTrayNotification',
                                        product?.displayName,
                                        i18next.t('tray-notice:maintenance-starts'),
                                        self.root.regionConfig.cdnHost + product?.cms?.navigationGameIcon,
                                        productId
                                    );
                            }, sleepTime);
                            // set maintenance end timer
                            if (endMaintTimers[productId]) clearTimeout(endMaintTimers[productId]);
                            let endSleepTime = end * 1000 - Date.now();
                            endSleepTime = endSleepTime > 0 ? endSleepTime : 0;
                            endMaintTimers[productId] = setTimeout(() => {
                                product?.maintenance.clear();
                            }, endSleepTime);
                        }
                        break;
                    case 'MaintenanceEnd':
                        {
                            const { productId, end } = d.body;
                            const product = self.root.appStore.library.find((x) => x.productId === productId);
                            let sleepTime = end * 1000 - Date.now();
                            sleepTime = sleepTime > 0 ? sleepTime : 0;
                            if (endMaintTimers[productId]) clearTimeout(endMaintTimers[productId]);
                            endMaintTimers[productId] = setTimeout(() => {
                                product?.maintenance.clear();
                                if (product?.trayNoticeAvailable)
                                    window.ipcRenderer.invoke(
                                        'showTrayNotification',
                                        product?.displayName,
                                        i18next.t('tray-notice:maintenance-ends'),
                                        self.root.regionConfig.cdnHost + product?.cms?.navigationGameIcon,
                                        productId
                                    );
                            }, sleepTime);
                        }
                        break;
                    case 'NotificationCreated':
                        d.body.isRealtime = true;
                        self.root.notificationCenter.add(d.body);
                        break;
                    case 'NotificationModified':
                    case 'NotificationRemoved':
                        const notificationFound = self.root.notificationCenter.list.find((x) => x.notificationId === d.body.notificationId);
                        if (notificationFound) notificationFound.update(d.body.endAt ?? 0);
                        break;
                }
            },
            // error(event: Event) {},
            close(event: any) {
                if (self.pingTimeout) {
                    window.clearTimeout(self.pingTimeout);
                    self.pingTimeout = undefined;
                }
                self.state = 'closed';
                if (navigator.onLine === false) {
                    self.retry = 0;
                    return;
                }
                self.retry++;
                if (self.retry > 5) {
                    return;
                }
                setTimeout(() => {
                    actions.connect();
                }, Math.random() * 60 * 1000);
            },
            ping() {
                if (self.state !== 'connected') return;
                const msg = { headers: { eventType: 'PresencePing' }, body: {} };
                self.socket?.send(JSON.stringify(msg));
                self.pingTimeout = window.setTimeout(() => {
                    actions.ping();
                }, 60000);
            },
            connect() {
                if (['connecting', 'connected'].includes(self.state)) {
                    // actions.ping();
                    return;
                }
                self.state = 'connecting';
                const url = `wss://${settings.hosts.accounts.replace('https://', '')}/api/notification/v1/socket?product_id=10000`;
                self.socket = new WebSocket(url);
                self.socket.onopen = actions.open;
                self.socket.onmessage = actions.message;
                // https://stackoverflow.com/questions/18803971/websocket-onerror-how-to-read-error-description
                // self.socket.onerror = actions.error;
                self.socket.onclose = actions.close;
            },
            send(msg: string) {},
        };
        return actions;
    });

export default GlobalNotification;
